'use client';

import { Button, Modal } from '@common/components';
import { usePathname } from 'next/navigation';
import { useShallow } from 'zustand/react/shallow';

import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useGlobalStore } from '@/stores/GlobalStore';

export const LoginRedirectionConfirmModal = () => {
  const router = useCustomRouter();
  const pathname = usePathname();
  const [
    isShowLoginRedirectionConfirmModal,
    setIsShowLoginRedirectionConfirmModal,
  ] = useGlobalStore(
    useShallow(
      (state) =>
        [
          state.isShowLoginRedirectionConfirmModal,
          state.setIsShowLoginRedirectionConfirmModal,
        ] as const,
    ),
  );

  const handleClickConfirm = () => {
    setIsShowLoginRedirectionConfirmModal(false);
    router.push(
      ROUTES.LOGIN.withSearchParams({
        searchParams: { redirect: pathname ?? '' },
      }),
    );
  };
  const handleClose = () => {
    setIsShowLoginRedirectionConfirmModal(false);
  };

  return (
    <Modal
      className="flex flex-col items-center"
      opened={isShowLoginRedirectionConfirmModal}
      onClose={handleClose}
    >
      <p className="mb-8 font-700 text-Gray-900 typo-body1">알림</p>
      <p className="mb-24 font-400 text-Gray-700 typo-body3">
        웰로에 회원가입을 하시고
        <br />
        정책 지원금을 확인해 보세요.
      </p>

      <Button
        className="cursor-pointer px-16 py-12 font-700 typo-body3"
        theme="primary-fill"
        onClick={handleClickConfirm}
      >
        웰로 시작하기
      </Button>
    </Modal>
  );
};
